// Module
var code = "<ngx-reset-password (on-success)=\"$ctrl.login()\" (on-forgot)=\"$ctrl.forgotPassword()\" [email]=\"$ctrl.email\" [expiry]=\"$ctrl.expiry\" [hash]=\"$ctrl.hash\"></ngx-reset-password>";
// Exports
module.exports = code;